module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "ded_f"
  }, [_c('span', [_vm._v("My appreciation goes out to these people without whom I couldn’t have written this book, and so it’s for each and every one of you:")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To Devi, for taking a chance, and being so incredibly supportive.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To Miriam, for always being in my corner.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To Dr. Chris Fletcher, for being part of the process. Thank you so much!")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To my sisters, for always being there for me no matter what.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To my favorite ginger, for the conversation that led to this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To my friends, for understanding and putting up with all the crazy. I love you all.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To Steve, for everything. Absolutely everything. I couldn’t do this without your love and support, and occasional kick in the butt.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To all the girls in trouble out there. I hope you find your way out.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("And to W. You survived and you thrived. You forgave the unforgivable and found peace. You are strength and grace incarnate.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793dbbbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0